import React from 'react';
import './Music.css';
import albumCover1 from '../images/Osondi_Owendi.jpg'; // Osondi Owendi by Chief Stephen Osita Osadebe.
import albumCover2 from '../images/onwa.webp'; // Onwa Special by Chief Dr. Emeka Morocco Maduka
import albumCover3 from '../images/ibalu_mmonwu.jpg'; // Ibalu Mmonwu by Chief Micheal Udegbi
import albumCover4 from '../images/My_Trust_Is_In_You.jpg'; // My Trust Is in You by David Gbenga Olusegun
import albumCover5 from '../images/Guide_Me.jpg'; // Guide Me by K3ndrick
import albumCover6 from '../images/Mad_At_You.jpg'; // Mad At You by ah cyrus, gallant
import albumCover7 from '../images/Seven_Days_Walking.jpg'; // Seven Days Walking by Ludovico Einaudi
import albumCover8 from '../images/Ora.jpg'; // Ora by Ludovico Einaudi
import albumCover9 from '../images/Fuori_Dal_Mondo.jpg'; // Fuori Dal Mondo by Ludovico Einaudi
import albumCover10 from '../images/Loi.jpg'; // Loi by Koffi Olomide
import albumCover11 from '../images/Coupé_Bibamba.jpg'; // Coupé Bibamba by Awilo Longomba
import albumCover12 from '../images/nishike.jpg'; // Nishike by Christian Bella
import albumCover13 from '../images/Kolapiano.jpg'; // Kolapiano.jpg by Kolaboy
import albumCover14 from '../images/Vuli_Ndlela.jpg'; // Vuli Ndlela by Brenda Fassie
import albumCover15 from '../images/egedege.jpg'; // Egedege by Umu Udu Bonch
import albumCover16 from '../images/oluoma.jpg'; // Oluoma by Umu Obiligbo ft. Duncan Mighty

const favoriteGenres = ["HighLife", "Gospel", "Afrobeat", "Pop", "Classical", "Champeta", "Blues", "Rap", "HipHop"];
const favoriteAlbums = [
  { title: "Osondi Owendi", artist: " 👑 Chief Stephen Osita Osadebe.", imgSrc: albumCover1 },
  { title: "Owan Special", artist: "Chief Dr. Emeka Morocco Maduka", imgSrc: albumCover2 },
  { title: "Ibalu Mmonwu", artist: "Chief Micheal Udegbi", imgSrc: albumCover3 },
  { title: "My Trust Is in You", artist: "David Gbenga Olusegun", imgSrc: albumCover4 },
  { title: "Guide Me", artist: "K3ndrick", imgSrc: albumCover5 },
  { title: "Mad At You", artist: "Noah Cyrus & Gallant", imgSrc: albumCover6 },
  { title: "Seven Days Walking", artist: "Ludovico Einaudi", imgSrc: albumCover7 },
  { title: "Ora", artist: "Ludovico Einaudi", imgSrc: albumCover8 },
  { title: "Fuori Dal Mondo", artist: "Franco Feruglio, Gabriele Baffero, Antonello Leofreddi, Mauro Loguercio, Marco Decimo, Ludovico Einaudi", imgSrc: albumCover9 },
  { title: "Loi", artist: "Koffi Olomide", imgSrc: albumCover10 },
  { title: "Coupé Bibamba", artist: "Awilo Longomba", imgSrc: albumCover11 },
  { title: "Nishike", artist: "Christian Bella", imgSrc: albumCover12 },
  { title: "Kolapiano", artist: "Kolaboy", imgSrc: albumCover13 },
  { title: "Vuli Ndlela", artist: "Brenda Fassie", imgSrc: albumCover14 },
  { title: "Egedege", artist: "Umu Udu Bonch", imgSrc: albumCover15 },
  { title: "Oluoma", artist: "Umu Obiligbo ft. Duncan Mighty", imgSrc: albumCover16 },
];

const Music: React.FC = () => {
  return (
    <div className="music-page">
      <div className="quote">
        <p>“Rock and Roll isn’t a genre, it’s a way of life.” 🎸</p>
      </div>

      <div className="genre-section">
        <h3>Explore by Genre</h3>
        <div className="genres">
          {favoriteGenres.map((genre, index) => (
            <div key={index} className="genre-card" style={{ animationDelay: `${index * 0.2}s` }}>
              <p>{genre}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="albums-section">
        <h3>Favorite Albums</h3>
        <div className="albums">
          {favoriteAlbums.map((album, index) => (
            <div key={index} className="album-card" style={{ animationDelay: `${index * 0.3}s` }}>
              <img src={album.imgSrc} alt={album.title} className="album-image" />
              <div className="album-details">
                <h4>{album.title}</h4>
                <p>by {album.artist}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Music;
